const cache = new Map(), pendentes = new Map();
let timer, versao=0;
const chave = (token,id) => token + ':' + id;
export function atualizarFinanciamento(id, status) {
  const token=sessionStorage.getItem('token');
  if(token)cache.set(chave(token,Number(id)),{at:Date.now(),valor:status,versao:++versao});
  window.dispatchEvent(new CustomEvent('leila:financiamento-atualizado',{detail:{id:Number(id),status}}));
}
export function consultarFinanciamento(id) {
  const token=sessionStorage.getItem('token'), n=Number(id);
  if(!token || !Number.isSafeInteger(n) || n<=0)return Promise.resolve(null);
  const key=chave(token,n), guardado=cache.get(key);
  if(guardado && Date.now()-guardado.at<60000)return Promise.resolve(guardado.valor);
  return new Promise(resolve=>{
    const p=pendentes.get(key)||{id:n,token,resolvers:[]};p.resolvers.push(resolve);pendentes.set(key,p);
    if(!timer)timer=setTimeout(enviar,0);
  });
}
async function enviar(){
 timer=null;const lote=[...pendentes.values()];pendentes.clear();
 for(const token of new Set(lote.map(p=>p.token))){
  const grupo=lote.filter(p=>p.token===token);
  for(let i=0;i<grupo.length;i+=100){
   const parte=grupo.slice(i,i+100),inicio=versao;let dados={};
   try{const r=await fetch((process.env.REACT_APP_API_URL||'')+'/api/leila/guiada/financiamentos?ids='+parte.map(p=>p.id).join(','),{headers:{Authorization:'Bearer '+token},cache:'no-store'});
    if(r.ok)dados=(await r.json()).financiamentos||{};
   }catch{}
   for(const p of parte){
    const key=chave(token,p.id),recente=cache.get(key);
    const valor=recente && recente.versao>inicio?recente.valor:dados[p.id]||null;
    if(sessionStorage.getItem('token')===token){if(!recente || recente.versao<=inicio)cache.set(key,{at:Date.now(),valor,versao:++versao});p.resolvers.forEach(resolve=>resolve(valor));}
    else p.resolvers.forEach(resolve=>resolve(null));
   }
  }
 }
 if(cache.size>1500){const agora=Date.now();for(const [k,v]of cache)if(agora-v.at>60000)cache.delete(k);}
}
